import React, { useEffect } from "react";
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { Auth0Provider } from "@auth0/auth0-react"
import { config } from "./config"
import "./lib/i18n"
import { StoreProviderShared } from "./store";
import axios from "axios";
import { StoreProviderPlayLogs } from "./modules/playLogs/store";
import { StoreProviderPlayer } from "./modules/player/store";
import { StoreProviderPlayers } from "./modules/players/store";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
let clientConfig: any;
// eslint-disable-next-line no-restricted-globals
axios.get('/MobileClientConfigurations?url='+location.host, {
  baseURL: config.api.url,
  headers: {
    "X-ApiKey": config.api.key,
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
  },
})
  .then((response) => {
    clientConfig = response?.data?.data.array[0];

    root.render(
      <Auth0Provider
        domain={config.auth0.domain}
        clientId={config.auth0.clientId}
        redirectUri={window.location.origin}
        name={"Portal - Staging"}
        logo={clientConfig ? clientConfig.loginLogo : "https://dsmanager.storever.com/content/images/logo-auth.png"}
        responseType={"token id_token"}
        audience={"https://api.storever.com/"}
        scope={"openid profile email"}
        useRefreshTokens
        RefreshTokenRotation
        cacheLocation={"localstorage"}
      >
        <StoreProviderShared>
          <StoreProviderPlayLogs>
            <StoreProviderPlayers>
              <StoreProviderPlayer>
                <App />
              </StoreProviderPlayer>
            </StoreProviderPlayers>
          </StoreProviderPlayLogs>
        </StoreProviderShared>
      </Auth0Provider>
    )
  }, (error) => {
    console.log(error);
    root.render(
      <Auth0Provider
        domain={config.auth0.domain}
        clientId={config.auth0.clientId}
        redirectUri={window.location.origin}
        name={"Portal - Staging"}
        logo={ "https://dsmanager.storever.com/content/images/logo-auth.png"}
        responseType={"token id_token"}
        audience={"https://api.storever.com/"}
        scope={"openid profile email"}
        useRefreshTokens
        RefreshTokenRotation
        cacheLocation={"localstorage"}
      >
        <StoreProviderShared>
          <StoreProviderPlayLogs>
            <StoreProviderPlayers>
              <StoreProviderPlayer>
                <App />
              </StoreProviderPlayer>
            </StoreProviderPlayers>
          </StoreProviderPlayLogs>
        </StoreProviderShared>
      </Auth0Provider>
    )
  });


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
